import type { ColumnsType } from 'antd/lib/table';
import type { FlightDefinitionRulesModel } from 'common/dataService';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import renderDeleteCell from './tableCells/renderDeleteCell';
import renderEditCell from './tableCells/renderEditCell';
import renderRegeneratePeriodCell from './tableCells/renderRegeneratePeriodCell';
import renderViewCell from './tableCells/renderViewCell';

const columns: ColumnsType<FlightDefinitionRulesModel> = [
  {
    key: 'name',
    title: <FormattedMessage id='name' />,
    dataIndex: 'name',
    sorter: true,
    render: (e, record) => <span style={{ minWidth: '250px', overflow: 'hidden' }}>{record.name}</span>,
  },
  {
    key: 'originGroups',
    title: <FormattedMessage id='addRule.originGroupsColumn' />,
    dataIndex: 'originGroups',
    render: (e, record) => <span>{record.originGroups.map((x) => x.name).join(', ')}</span>,
  },
  {
    key: 'destinationGroups',
    title: <FormattedMessage id='addRule.destinationGroupsColumn' />,
    dataIndex: 'destinationGroups',
    render: (e, record) => <span>{record.destinationGroups.map((x) => x.name).join(', ')}</span>,
  },
  {
    key: 'fromDaysToDeparture',
    title: <FormattedMessage id='addRule.fromDaysToDeparture' />,
    dataIndex: 'fromDaysToDeparture',
    sorter: true,
  },
  {
    key: 'toDaysToDeparture',
    title: <FormattedMessage id='addRule.toDaysToDeparture' />,
    dataIndex: 'toDaysToDeparture',
    sorter: true,
  },
  {
    key: 'generateForDepartureDate',
    title: 'Each Departure',
    dataIndex: 'generateForDepartureDate',
    render: (e, record) => <span>{record.generateForDepartureDate ? 'true' : 'false'}</span>,
  },
  {
    key: 'departures',
    title: 'Departures',
    dataIndex: 'departureDays',
    render: (e, record) => <span>{record.departureDays.join(', ')}</span>,
  },
  {
    key: 'generateForEachTripLength',
    title: 'Each Trip',
    dataIndex: 'generateForEachTripLength',
    render: (e, record) => <span>{record.generateForEachTripLength ? 'true' : 'false'}</span>,
  },
  {
    key: 'days',
    title: 'Trips',
    dataIndex: 'days',
    render: (e, record) => <span>{record.days.join(', ')}</span>,
  },
  {
    key: 'numberOfStops',
    title: <FormattedMessage id='addRule.numberOfStopsTable' />,
    dataIndex: 'numberOfStops',
  },
  {
    key: 'maxFlightsPerRoute',
    title: <FormattedMessage id='addRule.maxFlightsPerRoute' />,
    dataIndex: 'maxFlightsPerRoute',
  },
  {
    key: 'TotalGeneratedPeriods',
    title: <FormattedMessage id='addRule.countGeneratedPeriods' />,
    dataIndex: 'countGeneratedPeriods',
    sorter: true,
  },
  {
    key: 'viewActions',
    align: 'right' as const,
    fixed: 'right' as const,
    render: renderViewCell,
  },
  {
    key: 'editActions',
    align: 'right' as const,
    fixed: 'right' as const,
    render: renderEditCell,
  },
  {
    key: 'regenerateActions',
    align: 'right' as const,
    fixed: 'right' as const,
    render: renderRegeneratePeriodCell,
  },
  {
    key: 'deleteActions',
    align: 'right' as const,
    fixed: 'right' as const,
    render: renderDeleteCell,
  },
];

export default columns;
